import React from 'react'
import DownloadDriverForm from '../DownloadDriverForm'

const EpForm = () => {
  return (
    <>
 <DownloadDriverForm
        brand="EPSON"
        image="https://support-printers.netlify.app/img/Epson-Logo.png"
      />

    </>
  )
}

export default EpForm
